// Ensure the script runs after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Using IIFE to encapsulate code and avoid leaking into the global scope
  (function () {
    if (!customElements.get('product-sticky-form')) {
      var ProductStickyForm = class extends HTMLElement {
        _delegate = new main_default(this);

        connectedCallback() {
          this._setupVisibilityObservers();
          this._delegate.on('change', 'select[data-option-position]', this._syncMainForm.bind(this));

          // Throttle resize event listener to improve performance
          window.addEventListener('resize', debounce(this._handleResize.bind(this), 200));
        }

        disconnectedCallback() {
          this.intersectionObserver.disconnect();
          window.removeEventListener('resize', debounce(this._handleResize.bind(this), 200));
        }

        set hidden(value) {
          this.toggleAttribute('hidden', value);
          if (value) {
            document.documentElement.style.removeProperty('--cart-notification-offset');
          } else {
            document.documentElement.style.setProperty('--cart-notification-offset', `${this.clientHeight}px`);
          }
        }

        _syncMainForm(event) {
          const form = document.forms[this.getAttribute('form-id')];
          for (const element of form.elements) {
            if (element.name === event.target.name) {
              if (element.tagName === 'INPUT') {
                element.checked = element.value = event.target.value;
              }
            }
          }
        }

        _setupVisibilityObservers() {
          const paymentContainerElement = document.getElementById('MainPaymentContainer').closest('form'),
            footerElement = document.querySelector('.shopify-section--footer'),
            stickyHeaderOffset = getStickyHeaderOffset();

          this._isFooterVisible = this._isPaymentContainerPassed = false;

          const mobileAlwaysSticky = this.getAttribute('data-mobile-always-sticky');
          const mobileBreakpoint = parseInt(this.getAttribute('data-mobile-breakpoint'), 10) || 768; // Default breakpoint 768px

          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target === footerElement) {
                  this._isFooterVisible = entry.intersectionRatio > 0;
                }
                if (entry.target === paymentContainerElement) {
                  const boundingRect = paymentContainerElement.getBoundingClientRect();
                  this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
                }
              });

              this._updateVisibility(mobileAlwaysSticky, mobileBreakpoint);
            },
            { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
          );

          this.intersectionObserver.observe(paymentContainerElement);
          this.intersectionObserver.observe(footerElement);

          // Initial setup based on mode
          this._updateVisibility(mobileAlwaysSticky, mobileBreakpoint);
        }

        _updateVisibility(mobileAlwaysSticky, mobileBreakpoint) {
          const isMobile = window.innerWidth <= mobileBreakpoint;

          if (isMobile) {
            // Mobile-specific logic
            if (mobileAlwaysSticky === 'true') {
              this.hidden = this._isFooterVisible; // Always visible unless footer is visible
              window.removeEventListener('scroll', throttle(this._handleSmartScroll.bind(this), 100));
            } else if (mobileAlwaysSticky === 'smart') {
              this.hidden = this._isFooterVisible; // Start visible in smart mode, but hide if footer is visible
              window.addEventListener('scroll', throttle(this._handleSmartScroll.bind(this), 100));
            } else {
              // Fallback to original behavior if not 'smart' or 'true'
              this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
              window.removeEventListener('scroll', throttle(this._handleSmartScroll.bind(this), 100));
            }
          } else {
            // Desktop logic, same behavior regardless of mobile settings
            window.removeEventListener('scroll', throttle(this._handleSmartScroll.bind(this), 100));
            this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
          }
        }

        _handleResize() {
          const mobileAlwaysSticky = this.getAttribute('data-mobile-always-sticky');
          const mobileBreakpoint = parseInt(this.getAttribute('data-mobile-breakpoint'), 10) || 768; // Default breakpoint 768px

          // Update visibility immediately on resize to adjust between mobile and desktop
          this._updateVisibility(mobileAlwaysSticky, mobileBreakpoint);
        }

        _handleSmartScroll() {
          const mobileBreakpoint = parseInt(this.getAttribute('data-mobile-breakpoint'), 10) || 768; // Default breakpoint 768px
          const scrollThreshold = 100; // Arbitrary small scroll distance to hide the sticky bar initially

          if (window.innerWidth <= mobileBreakpoint) {
            if (this._isFooterVisible) {
              this.hidden = true; // Hide if the footer is visible
            } else if (window.scrollY > scrollThreshold && !this._isPaymentContainerPassed) {
              this.hidden = true; // Hide after slight scroll
            } else if (this._isPaymentContainerPassed) {
              this.hidden = false; // Show when past buy buttons
            } else if (window.scrollY <= scrollThreshold) {
              this.hidden = false; // Show when scrolled back up
            }
          } else {
            window.removeEventListener('scroll', throttle(this._handleSmartScroll.bind(this), 100));
            this._updateVisibility('false', mobileBreakpoint); // Revert to non-smart behavior on resize to desktop
          }
        }
      };

      window.customElements.define('product-sticky-form', ProductStickyForm);
    }

    // Utility functions to throttle and debounce
    function throttle(func, limit) {
      let inThrottle;
      return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => (inThrottle = false), limit);
        }
      };
    }

    function debounce(func, delay) {
      let debounceTimer;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
      };
    }
  })();
});

// if (!customElements.get('product-sticky-form')) {
//   var ProductStickyForm = class extends HTMLElement {
//     _delegate = new main_default(this);

//     connectedCallback() {
//       this._setupVisibilityObservers();
//       this._delegate.on('change', 'select[data-option-position]', this._syncMainForm.bind(this));

//       // Listen for resize events to handle screen size changes
//       window.addEventListener('resize', this._handleResize.bind(this));
//     }

//     disconnectedCallback() {
//       this.intersectionObserver.disconnect();
//       window.removeEventListener('resize', this._handleResize.bind(this));
//     }

//     set hidden(value) {
//       this.toggleAttribute('hidden', value);
//       if (value) {
//         document.documentElement.style.removeProperty('--cart-notification-offset');
//       } else {
//         document.documentElement.style.setProperty('--cart-notification-offset', `${this.clientHeight}px`);
//       }
//     }

//     _syncMainForm(event) {
//       const form = document.forms[this.getAttribute('form-id')];
//       for (const element of form.elements) {
//         if (element.name === event.target.name) {
//           if (element.tagName === 'INPUT') {
//             element.checked = element.value = event.target.value;
//           }
//         }
//       }
//     }

//     _setupVisibilityObservers() {
//       const paymentContainerElement = document.getElementById('MainPaymentContainer').closest('form'),
//         footerElement = document.querySelector('.shopify-section--footer'),
//         stickyHeaderOffset = getStickyHeaderOffset();

//       this._isFooterVisible = this._isPaymentContainerPassed = false;

//       const mobileAlwaysSticky = this.getAttribute('data-mobile-always-sticky');
//       const mobileBreakpoint = parseInt(this.getAttribute('data-mobile-breakpoint'), 10) || 768; // Default breakpoint 768px

//       this.intersectionObserver = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             if (entry.target === footerElement) {
//               this._isFooterVisible = entry.intersectionRatio > 0;
//             }
//             if (entry.target === paymentContainerElement) {
//               const boundingRect = paymentContainerElement.getBoundingClientRect();
//               this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
//             }
//           });

//           this._updateVisibility(mobileAlwaysSticky, mobileBreakpoint);
//         },
//         { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
//       );

//       this.intersectionObserver.observe(paymentContainerElement);
//       this.intersectionObserver.observe(footerElement);

//       // Initial setup based on mode
//       this._updateVisibility(mobileAlwaysSticky, mobileBreakpoint);
//     }

//     _updateVisibility(mobileAlwaysSticky, mobileBreakpoint) {
//       const isMobile = window.innerWidth <= mobileBreakpoint;

//       if (isMobile) {
//         // Mobile-specific logic
//         if (mobileAlwaysSticky === 'true') {
//           this.hidden = this._isFooterVisible; // Always visible unless footer is visible
//           window.removeEventListener('scroll', this._handleSmartScroll.bind(this));
//         } else if (mobileAlwaysSticky === 'smart') {
//           this.hidden = this._isFooterVisible; // Start visible in smart mode, but hide if footer is visible
//           window.addEventListener('scroll', this._handleSmartScroll.bind(this));
//         } else {
//           // Fallback to original behavior if not 'smart' or 'true'
//           this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
//           window.removeEventListener('scroll', this._handleSmartScroll.bind(this));
//         }
//       } else {
//         // Desktop logic, same behavior regardless of mobile settings
//         window.removeEventListener('scroll', this._handleSmartScroll.bind(this));
//         this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
//       }
//     }

//     _handleResize() {
//       const mobileAlwaysSticky = this.getAttribute('data-mobile-always-sticky');
//       const mobileBreakpoint = parseInt(this.getAttribute('data-mobile-breakpoint'), 10) || 768; // Default breakpoint 768px

//       // Update visibility immediately on resize to adjust between mobile and desktop
//       this._updateVisibility(mobileAlwaysSticky, mobileBreakpoint);
//     }

//     _handleSmartScroll() {
//       const mobileBreakpoint = parseInt(this.getAttribute('data-mobile-breakpoint'), 10) || 768; // Default breakpoint 768px
//       const scrollThreshold = 100; // Arbitrary small scroll distance to hide the sticky bar initially

//       if (window.innerWidth <= mobileBreakpoint) {
//         if (this._isFooterVisible) {
//           this.hidden = true; // Hide if the footer is visible
//         } else if (window.scrollY > scrollThreshold && !this._isPaymentContainerPassed) {
//           this.hidden = true; // Hide after slight scroll
//         } else if (this._isPaymentContainerPassed) {
//           this.hidden = false; // Show when past buy buttons
//         } else if (window.scrollY <= scrollThreshold) {
//           this.hidden = false; // Show when scrolled back up
//         }
//       } else {
//         window.removeEventListener('scroll', this._handleSmartScroll.bind(this));
//         this._updateVisibility('false', mobileBreakpoint); // Revert to non-smart behavior on resize to desktop
//       }
//     }
//   };

//   window.customElements.define('product-sticky-form', ProductStickyForm);
// }

// if (!customElements.get('product-sticky-form')) {
//   var ProductStickyForm = class extends HTMLElement {
//     _delegate = new main_default(this);
//     connectedCallback() {
//       this._setupVisibilityObservers();
//       this._delegate.on('change', 'select[data-option-position]', this._syncMainForm.bind(this));
//     }
//     disconnectedCallback() {
//       this.intersectionObserver.disconnect();
//     }
//     set hidden(value) {
//       this.toggleAttribute('hidden', value);
//       if (value) {
//         document.documentElement.style.removeProperty('--cart-notification-offset');
//       } else {
//         document.documentElement.style.setProperty('--cart-notification-offset', `${this.clientHeight}px`);
//       }
//     }
//     _syncMainForm(event) {
//       const form = document.forms[this.getAttribute('form-id')];
//       for (const element of form.elements) {
//         if (element.name === event.target.name) {
//           if (element.tagName === 'INPUT') {
//             element.checked = element.value = event.target.value;
//           }
//         }
//       }
//     }
//     _setupVisibilityObservers() {
//       const paymentContainerElement = document.getElementById('MainPaymentContainer').closest('form'),
//         footerElement = document.querySelector('.shopify-section--footer'),
//         stickyHeaderOffset = getStickyHeaderOffset();
//       this._isFooterVisible = this._isPaymentContainerPassed = false;
//       this.intersectionObserver = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             if (entry.target === footerElement) {
//               this._isFooterVisible = entry.intersectionRatio > 0;
//             }
//             if (entry.target === paymentContainerElement) {
//               const boundingRect = paymentContainerElement.getBoundingClientRect();
//               this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
//             }
//           });
//           if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
//             this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
//           } else {
//             this.hidden = !this._isPaymentContainerPassed;
//           }
//         },
//         { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
//       );
//       this.intersectionObserver.observe(paymentContainerElement);
//       this.intersectionObserver.observe(footerElement);
//     }
//   };
//   window.customElements.define('product-sticky-form', ProductStickyForm);
// }

// // js/custom-element/section/product/sticky-form.js
// if (!customElements.get('product-sticky-form')) {
//   var ProductStickyForm = class extends HTMLElement {
//     connectedCallback() {
//       document.getElementById(this.getAttribute('form-id'))?.addEventListener('variant:changed', this._onVariantChanged.bind(this));
//       this.imageElement = this.querySelector('.product-sticky-form__image');
//       this.priceElement = this.querySelector('.product-sticky-form__price');
//       this.comparePriceElement = this.querySelector('.product-sticky-form__price-compare');
//       this.unitPriceElement = this.querySelector('.product-sticky-form__unit-price');
//       this._setupVisibilityObservers();
//     }
//     disconnectedCallback() {
//       this.intersectionObserver.disconnect();
//     }
//     set hidden(value) {
//       this.toggleAttribute('hidden', value);
//       if (value) {
//         document.documentElement.style.removeProperty('--cart-notification-offset');
//       } else {
//         document.documentElement.style.setProperty('--cart-notification-offset', `${this.clientHeight}px`);
//       }
//     }

//     // _onVariantChanged(event) {
//     //   const variant = event.detail.variant,
//     //     currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
//     //   if (!variant) {
//     //     return;
//     //   }
//     //   if (this.priceElement) {
//     //     this.priceElement.innerHTML = formatMoney(variant['price'], currencyFormat);
//     //   }
//     //   if (this.unitPriceElement) {
//     //     this.unitPriceElement.style.display = variant['unit_price_measurement'] ? 'block' : 'none';
//     //     if (variant['unit_price_measurement']) {
//     //       let referenceValue = '';
//     //       if (variant['unit_price_measurement']['reference_value'] !== 1) {
//     //         referenceValue = `<span class="unit-price-measurement__reference-value">${variant['unit_price_measurement']['reference_value']}</span>`;
//     //       }
//     //       this.unitPriceElement.innerHTML = `
//     //       <div class="unit-price-measurement">
//     //         <span class="unit-price-measurement__price">${formatMoney(variant['unit_price'])}</span>
//     //         <span class="unit-price-measurement__separator">/</span>
//     //         ${referenceValue}
//     //         <span class="unit-price-measurement__reference-unit">${variant['unit_price_measurement']['reference_unit']}</span>
//     //       </div>
//     //     `;
//     //     }
//     //   }
//     //   if (!this.imageElement || !variant || !variant['featured_media']) {
//     //     return;
//     //   }
//     //   const featuredMedia = variant['featured_media'];
//     //   if (featuredMedia['alt']) {
//     //     this.imageElement.setAttribute('alt', featuredMedia['alt']);
//     //   }
//     //   this.imageElement.setAttribute('width', featuredMedia['preview_image']['width']);
//     //   this.imageElement.setAttribute('height', featuredMedia['preview_image']['height']);
//     //   this.imageElement.setAttribute('src', getSizedMediaUrl(featuredMedia, '165x'));
//     //   this.imageElement.setAttribute('srcset', getMediaSrcset(featuredMedia, [55, 110, 165]));
//     // }

//     _onVariantChanged(event) {
//       const variant = event.detail.variant,
//         currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
//       if (!variant) {
//         return;
//       }

//       // Update price and compare_at_price
//       if (this.priceElement) {
//         if (variant['compare_at_price'] && variant['compare_at_price'] > variant['price']) {
//           this.comparePriceElement.innerHTML = formatMoney(variant['compare_at_price'], currencyFormat);
//           this.comparePriceElement.style.display = 'inline-block'; // Make compare price visible
//           this.priceElement.innerHTML = formatMoney(variant['price'], currencyFormat);
//         } else {
//           this.comparePriceElement.style.display = 'none'; // Hide compare price if not applicable
//           this.priceElement.innerHTML = formatMoney(variant['price'], currencyFormat);
//         }
//       }

//       if (this.unitPriceElement) {
//         this.unitPriceElement.style.display = variant['unit_price_measurement'] ? 'block' : 'none';
//         if (variant['unit_price_measurement']) {
//           let referenceValue = '';
//           if (variant['unit_price_measurement']['reference_value'] !== 1) {
//             referenceValue = `<span class="unit-price-measurement__reference-value">${variant['unit_price_measurement']['reference_value']}</span>`;
//           }
//           this.unitPriceElement.innerHTML = `
//           <div class="unit-price-measurement">
//             <span class="unit-price-measurement__price">${formatMoney(variant['unit_price'])}</span>
//             <span class="unit-price-measurement__separator">/</span>
//             ${referenceValue}
//             <span class="unit-price-measurement__reference-unit">${variant['unit_price_measurement']['reference_unit']}</span>
//           </div>
//           `;
//         }
//       }

//       if (!this.imageElement || !variant || !variant['featured_media']) {
//         return;
//       }

//       const featuredMedia = variant['featured_media'];
//       if (featuredMedia['alt']) {
//         this.imageElement.setAttribute('alt', featuredMedia['alt']);
//       }
//       this.imageElement.setAttribute('width', featuredMedia['preview_image']['width']);
//       this.imageElement.setAttribute('height', featuredMedia['preview_image']['height']);
//       this.imageElement.setAttribute('src', getSizedMediaUrl(featuredMedia, '165x'));
//       this.imageElement.setAttribute('srcset', getMediaSrcset(featuredMedia, [55, 110, 165]));
//     }

//     // _setupVisibilityObservers() {
//     //   const paymentContainerElement = document.getElementById('buy_buttons'),
//     //     footerElement = document.querySelector('.shopify-section--footer'),
//     //     stickyHeaderOffset = getStickyHeaderOffset();
//     //   this._isFooterVisible = this._isPaymentContainerPassed = false;
//     //   this.intersectionObserver = new IntersectionObserver(
//     //     (entries) => {
//     //       entries.forEach((entry) => {
//     //         if (entry.target === footerElement) {
//     //           this._isFooterVisible = entry.intersectionRatio > 0;
//     //         }
//     //         if (entry.target === paymentContainerElement) {
//     //           const boundingRect = paymentContainerElement.getBoundingClientRect();
//     //           this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
//     //         }
//     //       });
//     //       if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
//     //         this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
//     //       } else {
//     //         this.hidden = !this._isPaymentContainerPassed;
//     //       }
//     //     },
//     //     { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
//     //   );
//     //   this.intersectionObserver.observe(paymentContainerElement);
//     //   this.intersectionObserver.observe(footerElement);
//     // }

//     _setupVisibilityObservers() {
//       const paymentContainerElement = document.getElementById('buy_buttons'),
//         footerElement = document.querySelector('.shopify-section--footer'),
//         stickyHeaderOffset = getStickyHeaderOffset();

//       this._isFooterVisible = this._isPaymentContainerPassed = false;

//       const updateVisibility = (entries) => {
//         entries.forEach((entry) => {
//           if (entry.target === footerElement) {
//             this._isFooterVisible = entry.intersectionRatio > 0;
//           }
//           if (entry.target === paymentContainerElement) {
//             const boundingRect = paymentContainerElement.getBoundingClientRect();
//             this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
//           }
//         });

//         if (!window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
//           // Use observer logic on desktop
//           this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
//         }
//       };

//       const handleResize = () => {
//         if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
//           // If it's mobile, disconnect the observer and make the form sticky at the bottom
//           this.intersectionObserver.disconnect();
//           this.hidden = false;
//         } else {
//           // If it's desktop, start observing
//           this.hidden = true; // Ensure it's hidden initially
//           this.intersectionObserver.observe(paymentContainerElement);
//           this.intersectionObserver.observe(footerElement);
//         }
//       };

//       // Create and configure IntersectionObserver
//       this.intersectionObserver = new IntersectionObserver(updateVisibility, {
//         rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px`,
//       });

//       // Set up the initial state
//       handleResize();

//       // Listen for resize events to toggle the observer and visibility
//       window.addEventListener('resize', handleResize);
//     }
//   };
//   window.customElements.define('product-sticky-form', ProductStickyForm);
// }
